const autocomplete = `
    query Autocomplete($input: AutocompleteInput!) {
        autocomplete(input: $input) {
            items {
                id
                type
                suggestion
            }
        }
    }
`;

const autocompleteFind = `
    query AutocompleteFind($input: AutocompleteInput!) {
        autocompleteFind(input: $input) {
            items {
                id
                type
                suggestion
            }
        }
    }
`;

const retrieveAddress = `
    query RetrieveAddress($id: String!) {
        retrieveAddress(id: $id) {
            id
            street
            city
            country {
                code
            }
            postcode
        }
    }
`;

export default {
    autocomplete,
    autocompleteFind,
    retrieveAddress,
}
